import { render, staticRenderFns } from "./IngredientView.vue?vue&type=template&id=7a692c7c&scoped=true"
import script from "./IngredientView.vue?vue&type=script&lang=js"
export * from "./IngredientView.vue?vue&type=script&lang=js"
import style0 from "./IngredientView.vue?vue&type=style&index=0&id=7a692c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a692c7c",
  null
  
)

export default component.exports